/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Lok Thapa's Portfolio",
  description:
    "Senior Software Engineer and technical lead with 14+ years designing cloud-native, event-driven applications across healthcare, finance, automotive, and investment domains.",
  og: {
    title: "Lok Thapa Portfolio",
    type: "website",
    url: "",
  },
};

//Home Page
const greeting = {
  title: "Lok Thapa",
  logo_name: "LokThapa",
  subTitle:
    "A passionate software engineer who enjoys working across the entire product lifecycle, from architecture and design to development and deployment. I love building scalable, resilient systems that solve real-world problems and create meaningful impact.\n\nWhen I'm not shipping code, I'm probably reading about it, running from it, or plotting my next escape (destination: TBD).",
  linkedin: "https://linkedin.com/in/lbt19",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/lokth/",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://linkedin.com/in/lbt19",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:lokb.thapa88@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Backend & Microservices",
      fileName: "FullStackImg",
      skills: [
        "⚡ Designing and building cloud-native, event-driven microservices with Java, Spring Boot and Spring Cloud",
        "⚡ Building resilient distributed systems and messaging pipelines with Apache Kafka",
        "⚡ Developing server-side applications with NodeJS and Python across healthcare, finance, automotive and investment domains",
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Spring / Spring Boot",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Hibernate",
          fontAwesomeClassname: "simple-icons:hibernate",
          style: {
            color: "#59666C",
          },
        },
        {
          skillName: "Apache Kafka",
          fontAwesomeClassname: "simple-icons:apachekafka",
          style: {
            color: "#231F20",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos:nodejs-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Frontend Development",
      fileName: "DesignImg",
      skills: [
        "⚡ Building responsive, single-page applications with Angular",
        "⚡ Crafting clean, semantic UI markup with HTML5 and modern JavaScript",
        "⚡ Integrating front-end apps with REST APIs secured via OAuth2 and JWT",
      ],
      softwareSkills: [
        {
          skillName: "Angular",
          fontAwesomeClassname: "logos:angular-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
          style: {
            color: "#1572B6",
          },
        },
      ],
    },
    {
      title: "Cloud & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Architecting and deploying scalable workloads on AWS and Azure",
        "⚡ Automating infrastructure and delivery pipelines with Terraform, Jenkins, Docker and Kubernetes",
        "⚡ Managing source control and CI/CD workflows with Git and Bitbucket",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "simple-icons:terraform",
          style: {
            color: "#7B42BC",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          style: {
            color: "#D24939",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F05032",
          },
        },
        {
          skillName: "Bitbucket",
          fontAwesomeClassname: "simple-icons:bitbucket",
          style: {
            color: "#0052CC",
          },
        },
      ],
    },
    {
      title: "Data & API Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Modeling and managing relational and NoSQL data stores including MySQL, PostgreSQL, MongoDB, DynamoDB and Redis",
        "⚡ Designing secure REST APIs documented with Swagger/OpenAPI and protected with OAuth2 and JWT",
        "⚡ Caching and optimizing data access patterns to keep high-throughput services fast and reliable",
      ],
      softwareSkills: [
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "DynamoDB",
          fontAwesomeClassname: "simple-icons:amazondynamodb",
          style: {
            color: "#4053D6",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "simple-icons:redis",
          style: {
            color: "#DC382D",
          },
        },
        {
          skillName: "Swagger / OpenAPI",
          fontAwesomeClassname: "simple-icons:swagger",
          style: {
            color: "#85EA2D",
          },
        },
        {
          skillName: "JWT",
          fontAwesomeClassname: "simple-icons:jsonwebtokens",
          style: {
            backgroundColor: "white",
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_lok.PNG",
    description:
      "Senior Software Engineer with 14+ years of experience building scalable microservices, cloud-native and event-driven applications for enterprise-scale organizations. I design resilient, high-performance solutions that solve complex business and technical challenges. Feel free to reach out for opportunities or collaboration.",
  },
  blogSection: {
    title: "Let's Connect",
    subtitle: "Reach out or connect with me on LinkedIn.",
    link: "https://linkedin.com/in/lbt19",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Melissa, TX",
    locality: "Melissa",
    country: "USA",
    region: "Texas",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/search/?api=1&query=Melissa,+TX",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "469-333-1419",
  },
};

export { settings, seo, greeting, socialMediaLinks, skills, contactPageData };
